import { Route } from 'react-router-dom';
import Guidance from 'pages/guidance'
import OTIGuidance from "modules/intensiveCare/components/Guidance/OTIGuidance";
import Drugs from "pages/drugs";
import * as drugsData from "config/data";
import Drug from 'pages/drug';
import DrugType from 'modules/intensiveCare/models/DrugType';

const Iot = [
  <Route
    exact
    path="/orotracheal-intubation/guidance"
    key="/orotracheal-intubation/guidance"
    render={() => <Guidance title="Intubação Orotraqueal"><OTIGuidance /></Guidance>}
  />,
  <Route
    exact
    path="/orotracheal-intubation/drugs/"
    key="/orotracheal-intubation/drugs/"
    render={({ match }) => <Drugs
      title="Intubação Orotraqueal"
      subtitle="Drogas"
      drugs={drugsData.rapidSequence}
      path={match.path}
    />}
  />,
  <Route 
    exact 
    path="/orotracheal-intubation/drugs/:drugKey"
    key="/orotracheal-intubation/drugs/:drugKey"
    render={props => <Drug drugType={DrugType.RAPID_SEQUENCE} drugId={props.match.params.drugKey} />}
  />,
]

export default Iot;
